import React from "react";

export default function No() {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 35C0 15.6765 15.6765 0 35 0C54.3235 0 70 15.6765 70 35C70 54.3235 54.3235 70 35 70C15.6765 70 0 54.3235 0 35ZM35 5.38462C18.6504 5.38462 5.38462 18.6504 5.38462 35C5.38462 51.3496 18.6504 64.6154 35 64.6154C51.3496 64.6154 64.6154 51.3496 64.6154 35C64.6154 18.6504 51.3496 5.38462 35 5.38462Z"
        fill="#DD0244"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.3276 22.3268C23.379 21.2754 25.0837 21.2754 26.1351 22.3268L35.0006 31.1922L43.8661 22.3268C44.9175 21.2754 46.6222 21.2754 47.6736 22.3268C48.725 23.3782 48.725 25.0829 47.6736 26.1343L38.8081 34.9997L47.6736 43.8652C48.725 44.9166 48.725 46.6213 47.6736 47.6727C46.6222 48.7241 44.9175 48.7241 43.8661 47.6727L35.0006 38.8072L26.1351 47.6727C25.0837 48.7241 23.379 48.7241 22.3276 47.6727C21.2762 46.6213 21.2762 44.9166 22.3276 43.8652L31.1931 34.9997L22.3276 26.1343C21.2762 25.0829 21.2762 23.3782 22.3276 22.3268Z"
        fill="#DD0244"
      />
    </svg>
  );
}
